module.exports = __webpack_public_path__ + "img/guobing.02adb45b.jpg";